import { create } from "zustand";

export const useTaskStore = create((set) => ({
  counts: {
    TODO: 0,
    IN_PROGRESS: 0,
    HOLD: 0,
    REVIEW: 0,
    DONE: 0,
  },
  selectedStatusFilter: null, // 'TODO', 'IN_PROGRESS', 'HOLD', 'REVIEW', 'DONE'
  setCounts: (counts) => set({ counts }),
  setSelectedStatusFilter: (status) => set({ selectedStatusFilter: status }),
}));
